import { TOTALS_KEY } from "constants/tableConversion"
import { RawDataCell, RawDataRow, ProcessedHeader } from "types/tableConversion.types"

interface HeaderProcessingState {
  currentGroup: RawDataCell
  groupColumns: string[]
  hasStartedGrouping: boolean
}

/**
 * Processes headers for XTAB_MULTI format with sub-header support
 */
export const processHeaders = (
  headersRow: RawDataRow,
  subHeadersRow: RawDataRow,
  isSubHeaderPresent: boolean
): ProcessedHeader[] => {
  if (!isSubHeaderPresent) {
    return headersRow.map(headerCell => ({
      header: headerCell,
      subHeaders: [],
    }))
  }

  const headers: ProcessedHeader[] = []
  const state: HeaderProcessingState = {
    currentGroup: null,
    groupColumns: [],
    hasStartedGrouping: false,
  }

  headersRow.forEach((headerCell, index) => {
    const subHeaderValue = String(subHeadersRow[index] || "")

    // Handle "Totals" as independent group
    if (subHeaderValue === TOTALS_KEY) {
      saveCurrentGroup(headers, state)
      headers.push({
        header: TOTALS_KEY,
        subHeaders: [TOTALS_KEY],
      })
      resetState(state)
      return
    }

    // Handle new header group
    if (headerCell !== null && headerCell !== "" && headerCell !== state.currentGroup) {
      saveCurrentGroup(headers, state)
      state.currentGroup = headerCell
      state.groupColumns = [subHeaderValue]
      state.hasStartedGrouping = true
    } else {
      state.groupColumns.push(subHeaderValue)
      state.hasStartedGrouping = true
    }
  })

  // Save final group
  saveCurrentGroup(headers, state)

  return headers
}

/**
 * Saves the current header group to the headers array
 */
const saveCurrentGroup = (headers: ProcessedHeader[], state: HeaderProcessingState): void => {
  if (!state.hasStartedGrouping) return

  headers.push({
    header: state.currentGroup,
    subHeaders: [...state.groupColumns],
  })
}

/**
 * Resets the header processing state
 */
const resetState = (state: HeaderProcessingState): void => {
  state.currentGroup = null
  state.groupColumns = []
  state.hasStartedGrouping = false
}